function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import Button from 'components/Form/Button';
import App from 'modules/App';
import CloudDrive from 'modules/CloudDrive';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
var _React_PureComponent;
class ReauthorizeCloudDrive extends (_React_PureComponent = React.PureComponent) {
    componentDidMount() {
        if (this.props.authorizationCode) {
            this.props.onReauthorizeCloudDrive(this.props.authorizationCode);
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.authorizationCode !== this.props.authorizationCode && this.props.authorizationCode) {
            this.props.onReauthorizeCloudDrive(this.props.authorizationCode);
        }
    }
    onAuthorizeCloudDrive() {
        const { storageProvider } = this.props.patientProfile;
        this.props.onAuthorizeCloudDrive(storageProvider, 'pwdReAuth');
    }
    render() {
        const cloudDriveType = get(App.constants.CLOUD_DRIVES_LABELS, get(this.props.patientProfile, 'storageProvider'));
        return /*#__PURE__*/ _jsxs("section", {
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "section__header",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.headers.cloudDrive), {
                        values: {
                            cloudDriveType
                        }
                    }))
                }),
                /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: messages.buttons.reauthorizeCloudDrive,
                    className: "btn--filled",
                    isInProgress: this.props.isReauthorizeCloudDriveInProgress,
                    onClick: ()=>this.onAuthorizeCloudDrive()
                })
            ]
        });
    }
}
_define_property(ReauthorizeCloudDrive, "propTypes", {
    // Explicit props
    patientProfile: PropTypes.object.isRequired,
    // Implicit props
    authorizationCode: CloudDrive.shapes.authorizationCode,
    isReauthorizeCloudDriveInProgress: PropTypes.bool,
    // Implicit actions
    onReauthorizeCloudDrive: PropTypes.func,
    onAuthorizeCloudDrive: PropTypes.func
});
const mapStateToProps = (state)=>({
        isReauthorizeCloudDriveInProgress: selectors.isReauthorizePatientProfileCloudDriveInProgress(state),
        authorizationCode: CloudDrive.selectors.authorizationCode(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onReauthorizeCloudDrive: (authorizationCode)=>dispatch(actions.reauthorizePatientProfileCloudDrive(authorizationCode)),
        onAuthorizeCloudDrive: (provider, type)=>dispatch(CloudDrive.actions.authorize(provider, type))
    });
const ConnectedReauthorizeCloudDrive = connect(mapStateToProps, mapDispatchToProps)(ReauthorizeCloudDrive);
export default ConnectedReauthorizeCloudDrive;
